import Loading from '@/component/mui/Backdrop';
import { useWeb3 } from '@/hooks/use-web3';
import { bigNumberRes, fiexdDecimal, hexToUtf, NumWithComma, trimTrailingZeros } from '@/lib/BigNumbers';
import { COIN_NAME_METIC, COIN_NAME_SFL, COIN_NAME_TRI, POLYGON_SHUFFLE, POLYGON_TRI } from '@/lib/common/name-space';
import { promiseStatus } from '@/lib/Promise';
import { weiToEth } from '@/lib/web3/utils';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import TxList from './TxList';
import { ResTxHistoryProps } from '@/types';
import { utcToAddTime } from '@/lib/dayjs';
import { Container } from '@mui/material';
import TopBackButton from '@/component/common/top-back-button';
import { heightSortByDesc } from '@/lib/txList';

export default function WalletDetail() {
  const { t } = useTranslation();
  const { web3authCall } = useWeb3();
  const {
    state: { symbol },
  } = useLocation();

  const [list, setList] = useState<ResTxHistoryProps[]>();
  const [isLoading, setIsLoading] = useState(true);

  const addr = useRef('');

  useEffect(() => {
    (async () => {
      if (web3authCall?.connected()) {
        const address = await web3authCall.getAddress();
        addr.current = address;
        let arrPromise = [];
        const fromPromise = (contractAddr?: string) =>
          web3authCall.getAlchemy().getTxHistory(address, 'from', contractAddr);
        const toPromise = (contractAddr?: string) =>
          web3authCall.getAlchemy().getTxHistory(address, 'to', contractAddr);

        if (symbol === COIN_NAME_METIC) {
          arrPromise.push(fromPromise(), toPromise());
        } else if (symbol === COIN_NAME_SFL) {
          arrPromise.push(fromPromise(POLYGON_SHUFFLE), toPromise(POLYGON_SHUFFLE));
        } else if (symbol === COIN_NAME_TRI) {
          arrPromise.push(fromPromise(POLYGON_TRI), toPromise(POLYGON_TRI));
        }
        if (arrPromise.length === 0) {
          setIsLoading(false);
          return;
        }
        const re = await Promise.allSettled(arrPromise);
        const res = promiseStatus(re);
        const arr = [...res[0].transfers, ...res[1].transfers];

        const sortedResults = arr.map((item) => {
          const obj: ResTxHistoryProps = {
            ...item,
            block: hexToUtf(item.blockNum),
            value: bigNumberRes(weiToEth(hexToUtf(item.rawContract.value)), 6),
            timeStamp: utcToAddTime(String(item.metadata.blockTimestamp)),
          };
          return obj;
        });
        const result = heightSortByDesc(sortedResults);
        setList(result);
        setIsLoading(false);
      }
    })();

    return () => {};
  }, [web3authCall]);

  return (
    <>
      <Container
        maxWidth="sm"
        sx={{
          minHeight: '653px',
          height: '100vh',
          position: 'relative',
        }}
      >
        <TopBackButton
          title="지갑 상세"
          boxProps={{
            mb: 4,
          }}
          backPath="/wallet"
        />
        <Loading isLoading={isLoading} />
        {list && <TxList list={list} symbol={symbol} addr={addr.current} />}
      </Container>
    </>
  );
}